import React from "react";
import Header from "../Components/Header";
import MarqueeComponent from "../Components/Marquee/MarqueeComponent";
import "../Css/FAQ.css";
import { Accordion } from "react-bootstrap";
import Footer from "../Components/Footer";
import BannerComp from "../Components/BannerComp";
import { Fade } from "react-awesome-reveal";
import EducationBanner from "../Assets/EducationBanner.jpg";
import { MetaTags } from "react-meta-tags";

const FAQ = () => {
  return (
    <>

      <MetaTags>
        <title>Calibrated Diamonds | Sejal Exports</title>
        <meta title="Calibrated Diamonds | Sejal Exports" />
        <meta name="description" content=" Discover Calibrated Diamonds, precision-cut for flawless jewellery designs. Ideal for setting in rings, earrings, and other fine pieces." />
        <meta name="keywords" content="Melee Diamonds For Jewellery,Best Diamonds Collection ,Diamond Wholesaler ,Fancy Color Diamonds ,Melee Diamonds,Certified Melee Diamonds,Fancy Diamonds With Different Shape,Black Diamonds ,Certified Diamonds,Customized Diamonds,Certified Fancy diamond,Natural Diamonds ,Calibrated Diamonds ,Best Ntural Diamond Supplier ,Best Natural Diamond Exhibition ,Best Natural Diamond Dealer,Reasonable Diamond In USA,Fast Delivery Diamonds ,High Quality Diamond In USA,Best Diamond Company In USA,Diamond For Jewelry In USA,cheapest Rate Diamond In USA,Natural Melee Diamond In USA,Reasonable Diamond In UK,Fast Delivery ,High Quality Diamond In UK,Best Diamond Company In UK,Diamond For Jewellery In UK,cheapest Rate Diamond In UK,Melee Diamond In UK,Reasonable Diamond In Canada,Fast Delivery ,High Quality Diamond In Canada,Best Diamond Company In Canada,Diamond For Jewellery In Canada,cheapest Rate Diamond In Canada,Melee Diamond In Canada,Reasonable Diamond In Australia,Fast Delivery ,High Quality Diamond In Australia,Best Diamond Company In Australia,Diamond For Jewellery In Australia,cheapest Rate Diamond In Australia,Melee Diamond In Australia,Reasonable Diamante In Mexico,Fast Delivery ,High Quality Diamante In Mexico,Best Diamante Company In Mexico,Diamante For joyas In Mexico,cheapest Rate Diamante In Mexico,Melee Diamante In Mexico,Reasonable Diamante In Columbia,Fast Delivery ,High Quality Diamante In Columbia,Best Diamante Company In Columbia,Diamante For joyas In Columbia,cheapest Rate Diamante In Columbia,Melee Diamante In Columbia,Reasonable Diamante In Italy,Fast Delivery ,High Quality Diamante In Italy,Best Diamante Company In Italy,Diamante For gioielli In Italy,cheapest Rate Diamante In Italy,Melee Diamante In Italy,Reasonable Diamant In France,Fast Delivery ,High Quality Diamant In France,Best Diamant Company In France,Diamant For bijoux In France,cheapest Rate Diamant In France,Melee Diamant In France,Reasonable Diamant In Germany,Fast Delivery ,High Quality Diamant In Germany,Best Diamant Company In Germany,Diamant For Schmuck In Germany,cheapest Rate Diamant In Germany,Melee Diamant In Germany,Reasonable diamant In Denmark,Fast Delivery ,High Quality diamant In Denmark,Best diamant Company In Denmark,diamant For Schmuck In Denmark,cheapest Rate diamant In Denmark,Melee diamant In Denmark,Reasonable diamant In Sweden,Fast Delivery ,High Quality diamant In Sweden,Best diamant Company In Sweden,diamant For smycke In Sweden,cheapest Rate diamant In Sweden,Melee diamant In Sweden,Reasonable Diamond In South Africa,Fast Delivery ,High Quality Diamond In South Africa,Best Diamond Company In South Africa,Diamond For Jewellery In South Africa,cheapest Rate Diamond In South Africa,Melee Diamond In South Africa,Reasonable Diamond In Hong Kong,Fast Delivery ,High Quality Diamond In Hong Kong,Best Diamond Company In Hong Kong,Diamond For Jewellery In Hong Kong,cheapest Rate Diamond In Hong Kong,Melee Diamond In Hong Kong,Reasonable Diamond In Dubai,Fast Delivery ,High Quality Diamond In Dubai,Best Diamond Company In Dubai,Diamond For Jewellery In Dubai,cheapest Rate Diamond In Dubai,Melee Diamond In Dubai,Reasonable Diamond In Malaysia,Fast Delivery ,High Quality Diamond In Malaysia,Best Diamond Company In Malaysia,Diamond For Jewellery In Malaysia,cheapest Rate Diamond In Malaysia,Melee Diamond In Malaysia,Reasonable Diamond In Singapore,Fast Delivery ,High Quality Diamond In Singapore,Best Diamond Company In Singapore,Diamond For Jewellery In Singapore,cheapest Rate Diamond In Singapore,Melee Diamond In Singapore,Reasonable Diamond In Thailand,Fast Delivery ,High Quality Diamond In Thailand,Best Diamond Company In Thailand,Diamond For Jewellery In Thailand,cheapest Rate Diamond In Thailand,Melee Diamond In Thailand,Certified diamonds In India,Luxury diamonds In Dubai,Best Diamonds In Singapore ,Best Natural Diamond Dealer in Hong Kong,Diamond Dealer in Malaysia,Best Diamond Dealer in Thailand,Best Diamond Dealer in America,Best Diamond Dealer in United Kingdom,Best Diamond Dealer in Europe,Best Diamond Dealer in United State,Best Diamond Dealer in Australia,Certified diamonds In India,Luxury diamonds In Dubai,Best Diamonds In Singapore ,Best Natural Diamond Dealer in Hong Kong,Diamond Dealer in Malaysia,Best Diamond Dealer in Thailand,Best Diamond Dealer in America,Best Diamond Dealer in United Kingdom,Best Diamond Dealer in Europe,Best Diamond Dealer in United State,Best Diamond Dealer in Australia" />
        <link rel="canonical" href="https://sejalexports.in/calibrated-diamonds" />
        <meta http-equiv="cache-control" content="no-cache" />
        <meta http-equiv="expires" content="0" />
        <meta http-equiv="pragma" content="no-cache" />
        <meta property="og:title" content="Calibrated Diamonds | Sejal Exports" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sejalexports.in/" />
        <meta property="og:description" content=" Discover Calibrated Diamonds, precision-cut for flawless jewellery designs. Ideal for setting in rings, earrings, and other fine pieces." />
        <meta property="og:image" content="https://sejalexports.in/static/media/logo.3d243a21eddc9f360630.png" />
      </MetaTags>

      <Header />
      <BannerComp
        title="FAQ"
        breadcrumb={[
          {
            title: "Home",
            href: "/",
          },
          {
            title: "FAQ",
          },
        ]}
        image={EducationBanner}
      />
      <section style={{ backgroundColor: "rgb(240,240,240)" }}>
        <div className="py-5 container">
          {/* <h2 className='text-center education-title'> FAQ</h2> */}
          <div className="row">
            <div className="col-md-12">
              <Fade triggerOnce direction="up">
                <Accordion>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header className="container">
                      <h2 className="text-muted accordion-title">
                        Q.1) How do I trust the quality of your diamonds?{" "}
                      </h2>
                    </Accordion.Header>

                    <Accordion.Body className="container">
                      <p className="faq-ans-para">
                        Our assurance of 'true value diamonds' reflects in the
                        fact that we pay paramount attention to every detail of
                        our diamonds; right from procurement to processing to
                        delivery, which includes a mix of both; human &
                        mechanical modes of quality checks. Satisfied clients &
                        workforce are a testimony of our company's constant
                        endeavor to be a center of excellence for both products
                        & people. Rigorous assortments, stringent quality
                        checks, state - of - the - art facilities, client -
                        centric approach and policies, absolute transparency are
                        some of the attributes that have helped us scale newer &
                        higher horizons. We, at ‘the sejal group’; constantly
                        strive to adopt strategies that are solely
                        service-oriented to ensure optimum client satisfaction.
                        <ul>
                          <li>
                            {" "}
                            We are active member of following esteemed
                            associations / organizations:
                            <label className="d-block">
                              1) Responsible Jewellery Council (RJC){" "}
                            </label>
                            <label className="d-block">2) GJEPC </label>
                            <label className="d-block">3) Rapnet </label>
                            <label className="d-block">4) Idex </label>
                            <label className="d-block">5) PayPal </label>
                            <label className="d-block">
                              {" "}
                              6) Bharat Diamond Bourse{" "}
                            </label>
                            <label className="d-block"> 7) MJSA </label>
                          </li>
                          <li>
                            Also; the following declaration; on all our invoices
                            to our customers testifies our commitment to 'sale
                            of only 100% natural diamonds':
                            <label className="d-block">
                              “the diamonds; herein; invoiced are exclusively of
                              natural origin and untreated; based on personal
                              knowledge and / or written guarantees provided by
                              the supplier of these diamonds. The acceptance of
                              goods; herein; invoiced will be as per the WFDB
                              guidelines.”
                            </label>
                            <label className="d-block">
                              {" "}
                              “to the best of our knowledge and / or written
                              assurance from our suppliers, we state that
                              diamonds herein; invoiced have not been obtained
                              in violation of applicable national laws and / or
                              sanctions by the U.S. Department of treasury's
                              office of foreign assets control (OFAC) and have
                              not originated from the MBADA and marange
                              resources of Zimbabwe".
                            </label>
                          </li>
                          <li>
                            Most importantly; 'sejal group' aspires to be the
                            'preferred choice' of its clients with the best of
                            its products & services with 'utmost care' to the
                            smallest of client demands. Optimum client
                            satisfaction with the best of customer - centric
                            policies and most ethical business practices have
                            always been the core values at our company.
                          </li>
                        </ul>
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Fade>
              <hr />
              <Fade triggerOnce direction="up">
                <Accordion>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header className="container">
                      <h2 className="text-muted accordion-title">
                        Q.2) How do you assure the clients that the diamonds are
                        natural and conflict – free?{" "}
                      </h2>
                    </Accordion.Header>
                    <Accordion.Body className="container">
                      <p className="faq-ans-para">
                        Below mentioned declaration; on all our invoices to our
                        customers testifies our commitment to 'sale of only 100%
                        natural and conflict - free diamonds': “the diamonds;
                        herein; invoiced have been sourced from legitimate
                        sources not involved in funding conflict and in
                        compliance with united nations resolutions. The seller;
                        hereby; guarantees that these diamonds are conflict -
                        free, based on personal knowledge and / or written
                        guarantees provided by the supplier of these diamonds.”
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Fade>
              <hr />
              <Fade triggerOnce direction="up">
                <Accordion>
                  <Accordion.Item eventKey="3">
                    <Accordion.Header className="container">
                      <h2 className="text-muted accordion-title">
                        Q.3) Do you sell single cut diamonds, natts, light
                        brown, light color, brown shade or light shade diamonds?{" "}
                      </h2>
                    </Accordion.Header>
                    <Accordion.Body className="container">
                      <p className="faq-ans-para">
                        Yes, we do sell single cut diamonds from 0.60 - 1.40mm,
                        top top light brown diamonds (ttlb), top top light
                        colour (ttlc), light brown (lb), light colour (lc) and
                        along with natts from 0.5-3.2mm. Kindly send your
                        enquiry on ‘ websales@sejalgems.in’ for prices and orders.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Fade>
              <hr />
              <Fade triggerOnce direction="up">
                <Accordion>
                  <Accordion.Item eventKey="4">
                    <Accordion.Header className="container">
                      <h2 className="text-muted accordion-title">
                        Q.4) How do you cater to products I want to order but
                        not available on your website?{" "}
                      </h2>
                    </Accordion.Header>
                    <Accordion.Body className="container">
                      <p className="faq-ans-para">
                        Our large & varied inventory at sejal exports consists
                        of small melee diamonds from 0.50 - 3.20 mm in white
                        diamonds, top top light brown (ttlb), top top light
                        color (ttlc), light brown (lb), light color (lc), full
                        cut and single cut and natts in loose diamonds. We can
                        also cater to diamonds for certified diamonds from 0.20
                        - 10.00 cts. In GIA / IGI / HRD. Our website displays
                        the most - sought after diamonds at the most reasonable
                        prices and so, certain exclusive products might not be
                        displayed online. You may feel free to get in touch with
                        us at  websales@sejalgems.in; WhatsApp chat on +91
                        98338-03546; call on +91-22-4043 1111 for any enquiries
                        pertaining to products not listed on our website or can
                        click on send enquiry on our website.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Fade>
              <hr />
              <Fade triggerOnce direction="up">
                <Accordion>
                  <Accordion.Item eventKey="5">
                    <Accordion.Header className="container">
                      <h2 className="text-muted accordion-title">
                        Q.5) Shipment charges & procedures:{" "}
                      </h2>
                    </Accordion.Header>
                    <Accordion.Body className="container">
                      <p className="faq-ans-para">
                        <label className="d-block">
                          a) Sejal exports caters to worldwide shipments via
                          registered and secured shipping by various courier
                          companies which can be traced online through a unique
                          tracking id.
                        </label>
                        <label className="d-block">
                          b) Express shipments will be delivered within 6 - 10
                          working days with an additional shipment charge; based
                          on the location of delivery.
                        </label>
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Fade>
              <hr />
              <Fade triggerOnce direction="up">
                <Accordion>
                  <Accordion.Item eventKey="6">
                    <Accordion.Header className="container">
                      <h2 className="text-muted accordion-title">
                        Q.6) How long it will take for you to process my order?{" "}
                      </h2>
                    </Accordion.Header>
                    <Accordion.Body className="container">
                      <p className="faq-ans-para">
                        <label className="d-block">
                          a) Large and varied inventory enables sejal exports to
                          process orders within 2 - 3 days of receiving payment.
                        </label>
                        <label className="d-block">
                          b) Special / customized orders can be processed within
                          3 - 7 working days to match your parameters.
                        </label>
                        <label>
                          c) National and festive holidays are excluded from
                          working days for order closures.
                        </label>
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Fade>
              <hr />
              <Fade triggerOnce direction="up">
                <Accordion>
                  <Accordion.Item eventKey="7">
                    <Accordion.Header className="container">
                      <h2 className="text-muted accordion-title">
                        Q.7) Are online prices inclusive of all applicable taxes
                        / duties?
                      </h2>
                    </Accordion.Header>
                    <Accordion.Body className="container">
                      <p className="faq-ans-para">
                        <label className="d-block">
                          a) Online prices are 'not inclusive' of all applicable
                          taxes / duties.
                        </label>
                        <label className="d-block">
                          b) Special / customized orders can be processed within
                          3 - 7 working days to match your parameters.
                        </label>
                        <label>
                          b) All applicable local import laws / import duties /
                          customs charges / taxes if any; have to be checked and
                          borne by the buyer and sejal exports holds no
                          liability; thereof; for any delay due to laws /
                          customs / shipment charges / in your country.
                        </label>
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Fade>
              <hr />
              <Fade triggerOnce direction="up">
                <Accordion>
                  <Accordion.Item eventKey="8">
                    <Accordion.Header className="container">
                      <h2 className="text-muted accordion-title">
                        Q.8) What are the modes of payment allowed?
                      </h2>
                    </Accordion.Header>
                    <Accordion.Body className="container">
                      <p className="faq-ans-para">
                        Credit card, visa, American express, master card &
                        PayPal.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Fade>
              <hr />
              <Fade triggerOnce direction="up">
                <Accordion>
                  <Accordion.Item eventKey="9">
                    <Accordion.Header className="container">
                      <h2 className="text-muted accordion-title">
                        Q.9) What does the 15-day 'no questions asked’ return
                        policy mean?
                      </h2>
                    </Accordion.Header>
                    <Accordion.Body className="container">
                      <p className="faq-ans-para">
                        <label className="d-block">
                          a) The 15-day 'no questions asked' return policy
                          means; that the buyer is free to return the product;
                          even if they do not like it for any reason within the
                          first 15 days of receiving the goods by informing us
                          within the stipulated time frame.
                        </label>
                        <label className="d-block">
                          b) The products have to be returned in 'as is original
                          condition' to claim the refund.
                        </label>
                        <label>
                          c) Return policy will not be applicable; in case of
                          any damage / alteration / used-up condition found in
                          the product and any loss in value of the product, has
                          to be settled by the buyer.
                        </label>
                        <label className="d-block">
                          d) 'Sejal exports' decision in accepting the product
                          returned will be termed as 'final & binding' for both
                          parties involved.
                        </label>
                        <label className="d-block">
                          e) 'Customized & special orders' are not allowed for
                          any return / exchanges.
                        </label>
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Fade>
              <hr />
              <Fade triggerOnce direction="up">
                <Accordion>
                  <Accordion.Item eventKey="10">
                    <Accordion.Header className="container">
                      <h2 className="text-muted accordion-title">
                        Q.10) How do I return the product within 15 days?{" "}
                      </h2>
                    </Accordion.Header>
                    <Accordion.Body className="container">
                      <p className="faq-ans-para">
                        <label className="d-block">
                          a) Call us on 022-40431111 or drop us an e-mail at
                          ‘ websales@sejalgems.in’ with the detailed reasons for the
                          returned product.
                        </label>
                        <label className="d-block">
                          b) You are required to return the product in the
                          original package received by you from sejal exports
                          along with your name, address, contact & tracking
                          details.
                        </label>
                        <label>
                          c) Product has to be strictly returned in 'tamper
                          proof package' to avoid any loss in transit.
                        </label>
                        <label className="d-block">
                          d) Product has to be received by sejal exports in 'as
                          is original condition' to claim your refund promptly.
                        </label>
                        <label className="d-block">
                          e) Sejal exports; holds no liability for tempered
                          packages & customs clearance procedures.
                        </label>
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Fade>
              <hr />
              <Fade triggerOnce direction="up">
                <Accordion>
                  <Accordion.Item eventKey="11">
                    <Accordion.Header className="container">
                      <h2 className="text-muted accordion-title">
                        Q.11) Will I have to pay for shipping the product back
                        to you in case of any problem?{" "}
                      </h2>
                    </Accordion.Header>
                    <Accordion.Body className="container">
                      <p className="faq-ans-para">
                        Yes, return shipping charges plus 5% of invoice value
                        (on account of import duty) have to be borne by the
                        buyer. Alternatively, you can choose return shipping
                        company based on your budget and security of goods.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Fade>
              <hr />
              <Fade triggerOnce direction="up">
                <Accordion>
                  <Accordion.Item eventKey="12">
                    <Accordion.Header className="container">
                      <h2 className="text-muted accordion-title">
                        Q.12) How do I check if the delivery of diamonds is same
                        as the order placed on the website?
                      </h2>
                    </Accordion.Header>
                    <Accordion.Body className="container">
                      <p className="faq-ans-para">
                        "sejal group" aspires to achieve the 'unflinching trust
                        & faith' of its clients with the best of its 'quality
                        products & services'. You may get our diamonds checked
                        from any authorized dealer to confirm if the product
                        delivered matches the parameters of the order placed
                        online on website, by your esteemed self; as each
                        diamond is unique based on its own peculiar &
                        distinctive characteristics.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Fade>
              <hr />
              <Fade triggerOnce direction="up">
                <Accordion>
                  <Accordion.Item eventKey="13">
                    <Accordion.Header className="container">
                      <h2 className="text-muted accordion-title">
                        Q.13) feedback and suggestions:
                      </h2>
                    </Accordion.Header>
                    <Accordion.Body className="container">
                      <p className="faq-ans-para">
                        We are glad to hear from you any improvements that
                        facilitate ease in order processing. You may share your
                        suggestions at  websales@sejalgems.in or call us at
                        +91-22-40431111 from Monday – Saturday during 9.00 am –
                        6.30 pm IST.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Fade>
              <hr />
            </div>
          </div>
        </div>
      </section>
      <MarqueeComponent />
      <Footer />
    </>
  );
};

export default FAQ;
